@if (corporateTaxEntity$ | async) {
  <form [formGroup]="agrarischFg">
    <div class="row">
      <div class="col col-1 pt-3" style="max-width: 150px">
        <p>Productierechten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="productierechtenFiscaalAanschaffingskosten"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          label="Kostprijs"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="afschrijvingProductierechten"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          label="Afschrijving"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="productierechtenFiscaalBegin"
                                          label="Openingsbalans"
                                          align="right" prefix="€"
                                          class="custom-input-150"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="productierechtenFiscaalEnd"
                                          label="Slotbalans"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Dieren</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="dierenFiscaalAanschaffingskosten"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="dierenFiscaalRestwaarde"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="dierenFiscaalBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="dierenFiscaalEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Plant- en pootgoed</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="plantEnPootgoedFiscaalAanschaffingskosten"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="plantEnPootgoedFiscaalRestwaarde"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="plantEnPootgoedFiscaalBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="plantEnPootgoedFiscaalEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Overige activa</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="overigeActivaLandbouwAanschaffingskosten"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="overigeActivaLandbouwRestwaarde"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="overigeActivaLandbouwBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="overigeActivaLandbouwEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Voorraad dieren</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="voorraadDierenFiscaalBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="voorraadDierenFiscaalEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Voorraad bloembollen</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="voorraadBoelbollenFiscaalBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="voorraadBoelbollenFiscaalEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Voorraad champignons</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="voorraadChampignonsFiscaalBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="voorraadChampignonsFiscaalEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Voorraad veldinventaris</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="voorraadVeldinventarisFiscaalBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="voorraadVeldinventarisFiscaalEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col col-1" style="max-width: 150px">
        <p>Overige voorraad</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="voorraadOverigeLandbouwFiscaalBegin"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="voorraadOverigeLandbouwFiscaalEnd"
                                          class="custom-input-150"
                                          align="right" prefix="€"
                                          [showAllDecimals]="false"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>

  </form>
}
